import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { StateService } from 'src/app/_service/state.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-loader-button',
  templateUrl: './loader-button.component.html',
  styleUrls: ['./loader-button.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LoaderButtonComponent {
  @Input() text: string;
  @Input() disabled = false;
  @Input() icon: string;
  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();
  isLoading = false;
  isGloballyLoading = false;
  private subscription: Subscription | null = null;

  constructor(public stateService: StateService) {
    this.subscription = this.stateService.loadingStateObserver.subscribe(value => {
      this.isGloballyLoading = value;
    });
  }

  sendRequest(): void {
    if (this.stateService.loadingState) return;
    this.isLoading = true;
    this.stateService.loadingState = true;
    this.buttonClicked.emit();
  }

  requestFinished(){
    this.isLoading = false;
    this.stateService.loadingState = false;
    this.subscription = null;
  }

}
